import React, {Component} from 'react';
import {Link} from 'react-router'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as partnerActions from '../../../actions/partners';
import DataTable from '../../../components/data-table/data-table';
import LocalizedStrings from '../../../localization/strings';

class PartnersContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 0
        };
    }

    componentWillMount() {
        this.fetch({});
    }

    fetch(params) {
        const fetchParams = {
            ...this.state,
            ...params
        }
        this.setState(fetchParams);
        this.props.actions.fetchPartners(fetchParams.page, fetchParams.size);
    }

    removePartner(partner) {
        if (confirm(LocalizedStrings.doYouWantToRemove)) {
            this.props.actions.deletePartner(partner);
        }
    }

    render() {
        const {items, total, page, total_pages, loading} = this.props.partners;

        var config = {
            cols: [
                {
                    value: 'name',
                    header: LocalizedStrings.name
                }, {
                    value: 'order',
                    header: LocalizedStrings.order
                }, {
                    value: (item) => {
                        return item.partnerCategory ? item.partnerCategory.name : ''
                    },
                    header: LocalizedStrings.partnerCategory
                }, {
                    value: (item) => {
                        return (
                            <div className="btn-group">
                                <Link className="btn" to={`/admin/partners/${item.id}`}>{LocalizedStrings.edit}</Link>
                                <a className="btn btn-red"
                                   onClick={this.removePartner.bind(this, item)}>{LocalizedStrings.delete}</a>

                            </div>

                        )
                    },
                    header: LocalizedStrings.actions
                }
            ]
        };
        return (
            <div>
                <h3 className="first-uppercase">{LocalizedStrings.partners}</h3>
                <div className="table-actions-row">
                    <Link to="/admin/partners/new" className="btn btn-primary">
                        {LocalizedStrings.newPartner}
                    </Link>
                </div>
                <div className="panel">
                    <div className="panel-body">
                        <DataTable config={config} items={items} page={page} total={total} totalPages={total_pages}
                                   loadAction={this.fetch.bind(this)} loading={loading}/>
                    </div>
                </div>
            </div>

        )
    }
}

export default connect(function (state) {
    return {partners: state.admin.partners.partners};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...partnerActions
        }, dispatch)
    };
})(PartnersContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/partner/partners-container.js